export default "__VITE_ASSET__466446b7__"